// Module
var code = "<div layout=\"column\" class=\"full-height\"> <md-toolbar class=\"triangular-toolbar hidden-print default\" md-theme=\"{{$ctrl.selectedSkin.elements.toolbar}}\"> <top-nav-main></top-nav-main> </md-toolbar> <ui-view flex ng-if=\"$ctrl.isLoaded\"></ui-view> </div> ";
// Exports
export default code;